import React from 'react';
import { mockReceiptPayment, formatCurrency } from '../../../services/mockData';

const ReceiptPayment = () => {
  const r = mockReceiptPayment.receipts;
  const p = mockReceiptPayment.payments;

  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="breadcrumb">Bank &amp; Cash Reports <span>/ Receipt &amp; Payment</span></div>
        <h2>Receipt &amp; Payment Report</h2>
      </div>

      <div className="filter-bar">
        <div className="form-group">
          <label>List of Banks</label>
          <select className="form-control">
            <option>BANK OF INDIA-000252363252111, CASH-CASHINHAND</option>
          </select>
        </div>
        <div className="form-group">
          <label>From</label>
          <input type="text" className="form-control" defaultValue="01-04-2025" />
        </div>
        <div className="form-group">
          <label>To</label>
          <input type="text" className="form-control" defaultValue="01-02-2026" />
        </div>
        <div className="form-group" style={{ justifyContent: 'flex-end' }}>
          <div className="btn-group">
            <button className="btn btn-primary">🔍 Search</button>
            <button className="btn btn-warning btn-sm">🖨️ Print</button>
            <button className="btn btn-success btn-sm">📊 Export to Excel</button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="report-header">
          <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
          <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
          <p style={{ fontWeight: '700', marginTop: '6px' }}>
            Receipt &amp; Payments Report Financial Year: 2025-2026 on Dated: 01-02-2026, Date Range From: 01-04-2025 To: 01-02-2026
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          {/* RECEIPTS */}
          <div>
            <div className="section-title" style={{ marginBottom: '12px' }}>RECEIPTS</div>
            <table>
              <thead>
                <tr>
                  <th>Particulars</th>
                  <th className="amount">Bank of India</th>
                  <th className="amount">Cash</th>
                  <th className="amount">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>To Opening Balance</td>
                  <td className="amount">{formatCurrency(r.openingBalance.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(r.openingBalance.cash)}</td>
                  <td className="amount">{formatCurrency(r.openingBalance.total)}</td>
                </tr>
                <tr>
                  <td>Contra</td>
                  <td className="amount">{formatCurrency(r.contra.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(r.contra.cash)}</td>
                  <td className="amount">{formatCurrency(r.contra.total)}</td>
                </tr>
                <tr>
                  <td>Member Receipt</td>
                  <td className="amount">{formatCurrency(r.memberReceipt.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(r.memberReceipt.cash)}</td>
                  <td className="amount">{formatCurrency(r.memberReceipt.total)}</td>
                </tr>
                <tr>
                  <td>old bicycle sold</td>
                  <td className="amount">{formatCurrency(r.oldBicycleSold.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(r.oldBicycleSold.cash)}</td>
                  <td className="amount">{formatCurrency(r.oldBicycleSold.total)}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>Sub Total</td>
                  <td className="amount">{formatCurrency(r.subTotal.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(r.subTotal.cash)}</td>
                  <td className="amount">{formatCurrency(r.subTotal.total)}</td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* PAYMENTS */}
          <div>
            <div className="section-title" style={{ marginBottom: '12px' }}>PAYMENTS</div>
            <table>
              <thead>
                <tr>
                  <th>Particulars</th>
                  <th className="amount">Bank of India</th>
                  <th className="amount">Cash</th>
                  <th className="amount">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>To Opening Balance</td>
                  <td className="amount">{formatCurrency(p.openingBalance.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(p.openingBalance.cash)}</td>
                  <td className="amount">{formatCurrency(p.openingBalance.total)}</td>
                </tr>
                <tr>
                  <td>Contra</td>
                  <td className="amount">{formatCurrency(p.contra.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(p.contra.cash)}</td>
                  <td className="amount">{formatCurrency(p.contra.total)}</td>
                </tr>
                <tr>
                  <td>Salary</td>
                  <td className="amount">{formatCurrency(p.salary.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(p.salary.cash)}</td>
                  <td className="amount">{formatCurrency(p.salary.total)}</td>
                </tr>
                <tr>
                  <td>CCTV Camera</td>
                  <td className="amount">{formatCurrency(p.cctv.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(p.cctv.cash)}</td>
                  <td className="amount">{formatCurrency(p.cctv.total)}</td>
                </tr>
                <tr>
                  <td>Guard Salary Expenses</td>
                  <td className="amount">{formatCurrency(p.guardSalary.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(p.guardSalary.cash)}</td>
                  <td className="amount">{formatCurrency(p.guardSalary.total)}</td>
                </tr>
                <tr>
                  <td>Water Tanker Charges</td>
                  <td className="amount">{formatCurrency(p.waterTanker.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(p.waterTanker.cash)}</td>
                  <td className="amount">{formatCurrency(p.waterTanker.total)}</td>
                </tr>
                <tr>
                  <td>Rent</td>
                  <td className="amount">{formatCurrency(p.rent.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(p.rent.cash)}</td>
                  <td className="amount">{formatCurrency(p.rent.total)}</td>
                </tr>
                <tr>
                  <td>Less (5% Deducted)</td>
                  <td className="amount">{formatCurrency(p.tdsDeducted.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(p.tdsDeducted.cash)}</td>
                  <td className="amount">{formatCurrency(p.tdsDeducted.total)}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>Sub Total</td>
                  <td className="amount">{formatCurrency(p.subTotal.bankOfIndia)}</td>
                  <td className="amount">{formatCurrency(p.subTotal.cash)}</td>
                  <td className="amount">{formatCurrency(p.subTotal.total)}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '800' }}>Closing Balance</td>
                  <td className="amount" style={{ fontWeight: '800', color: '#2ec4b6' }}>{formatCurrency(p.closingBalance.bankOfIndia)}</td>
                  <td className="amount" style={{ fontWeight: '800', color: '#2ec4b6' }}>{formatCurrency(p.closingBalance.cash)}</td>
                  <td className="amount" style={{ fontWeight: '800', color: '#2ec4b6' }}>{formatCurrency(p.closingBalance.total)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptPayment;
